__turbopack_context__.v({
  "registerText": "5-module__QfsuDG__registerText",
  "sideBar": "5-module__QfsuDG__sideBar",
  "signInText": "5-module__QfsuDG__signInText",
  "winnerImage": "5-module__QfsuDG__winnerImage",
});
